import React from 'react'
import PropTypes from 'prop-types'
import styled, {css} from 'styled-components'
import {ListItemGraphic as RmwcListItemGraphic} from '@rmwc/list'
import '@rmwc/list/styles'

export const drawerListItemGraphicStyles = css`
  margin-right: 1rem;
`
export const drawerListItemGraphicPrimary2Styles = css`
  color: var(--mdc-theme-on-primary2);
`

const StyledRmwcListItemGraphic = styled(RmwcListItemGraphic)`
  &&& {
    ${drawerListItemGraphicStyles}
  }
  .mdc-theme--on-primary2 &&& {
    ${drawerListItemGraphicPrimary2Styles}
  }
`

const DrawerListItemGraphic = ({children, ...otherProps}) => <StyledRmwcListItemGraphic {...otherProps}>{children}</StyledRmwcListItemGraphic>

DrawerListItemGraphic.propTypes = {
  children: PropTypes.any
}

export {DrawerListItemGraphic}
